import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="query-checkout-status"
export default class extends Controller {
  static values = {
    pingUrl: String,
    successUrl: String,
    interval: { type: Number, default: 5000 }
  }

  intervalId = null

  connect() {
    this.startPinging()
  }

  disconnect() {
    this.stopPinging()
  }

  startPinging() {
    this.intervalId = setInterval(() => {
      this.ping()
    }, this.intervalValue)
  }

  stopPinging() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  async ping() {
    try {
      const response = await fetch(this.pingUrlValue, {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      })

      if (response.ok) {
        const data = await response.json()

        if (data.success) {
          this.stopPinging()
          window.location.href = this.successUrlValue
        }
      }
    } catch (error) {
      console.error("Query failed:", error)
    }
  }
}